// eslint-disable-next-line max-classes-per-file
import { Uuid } from '@ftr/contracts/type/shared'
import { CartItem } from './cart.model'

export class AddCartItems {
  static readonly type = '[Cart] Add Items'
  constructor(public readonly items: CartItem[]) {}
}

export class RemoveCartItem {
  static readonly type = '[Cart] Remove Item'
  constructor(public readonly itemId: Uuid) {}
}

export class UpdateCartItem {
  static readonly type = '[Cart] Update Item'
  constructor(
    public readonly itemId: Uuid,
    public readonly updates: Partial<Omit<CartItem, 'id'>>,
  ) {}
}

export class ClearCart {
  static readonly type = '[Cart] Clear'
}

export class SetCourtSystemId {
  static readonly type = '[Cart] Set Court System Id'
  constructor(public readonly courtSystemId: Uuid) {}
}
